import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar, Divider, Space } from 'antd';
import i18next from 'i18next';
import { getDisplayAddress } from 'utils/dataUtils';
import { formatDate } from 'utils/textUtils';

import { EnvironmentOutlined, UserOutlined } from '@ant-design/icons';
import { MessageIcon, PhoneRightIcon } from 'components/common/SVGIcon';
import { ChildrenItem as ChildrenItemProps } from 'types/contacts';

import { isEmpty } from 'lodash-es';
import { Contact } from 'generated/apis';
import ChildrenItem from './ChildrenItem';
import { ContactItemStyles } from './styles';
import TagUserType from '../TagUserType';

interface Props {
  item?: Contact;
}

const ContactItem = ({ item }: Props) => (
  <ContactItemStyles className="contact-item">
    <Link to={`/contacts/${item.id}/parent-profile`}>
      <div>
        <div className="contact-item__activity-time">
          {`${i18next.t('common.lastActive')} ${
            formatDate(item.lastActiveAt, 'DD MMM, YYYY [at] HH:mm') || ''
          }`}
        </div>
        <div className="contact-item__user">
          <div>
            <Avatar
              size={56}
              src={item.avatar}
              alt=""
              icon={<UserOutlined />}
            />
          </div>
          <div className="contact-item__user-info">
            <span className="name-user">{item?.fullName}</span>
            <div>
              <Space className="items-center my-4" wrap size={12}>
                {item?.contactTypes?.map((contactType, index) => (
                  <TagUserType key={index} userType={contactType} />
                ))}
              </Space>
            </div>
          </div>
        </div>

        <div className="contact-item__info">
          <div className="item-info">
            <PhoneRightIcon className="text-primary" />
            <span className="item-info__value">
              {item?.phone || i18next.t('error.waitingUpdate')}
            </span>
          </div>

          <div className="item-info">
            <MessageIcon className="text-primary" />
            <span className="item-info__value ellipsis-t-1">
              {item?.email || i18next.t('error.waitingUpdate')}
            </span>
          </div>

          <div className="item-info">
            <EnvironmentOutlined className="text-primary" />
            <span className="item-info__value ellipsis-t-1">
              {getDisplayAddress(item?.user) ||
                i18next.t('error.waitingUpdate')}
            </span>
          </div>
        </div>

        {isEmpty(item?.children) ? null : (
          <div className="contact-item__children">
            <Divider />

            {item?.children?.map((item: ChildrenItemProps, idx) => (
              <ChildrenItem key={String(idx)} child={item} />
            ))}
          </div>
        )}
      </div>
    </Link>
  </ContactItemStyles>
);

export default ContactItem;
